export const userConstants = {
    LOGIN_REQUEST: 'USERS_LOGIN_REQUEST',
    LOGIN_SUCCESS: 'USERS_LOGIN_SUCCESS',
    LOGIN_FAILURE: 'USERS_LOGIN_FAILURE',

    LOGOUT: 'USERS_LOGOUT',

    GETALL_REQUEST: 'USERS_GETALL_REQUEST',
    GETALL_SUCCESS: 'USERS_GETALL_SUCCESS',
    GETALL_FAILURE: 'USERS_GETALL_FAILURE',

    DASH_LIST_REQUEST: 'DASHBOARD_LIST_REQUEST',
    DASH_LIST_RECEIVE: 'DASHBOARD_LIST_RECEIVE',

    DASH_CONTENT_REQUEST: 'DASHBOARD_CONTENT_REQUEST',
    DASH_CONTENT_RECEIVE: 'DASHBOARD_CONTENT_RECEIVE',

    TEMPLATE_LIST_REQUEST: 'TEMPLATE_LIST_REQUEST',
    TEMPLATE_LIST_RECEIVE: 'TEMPLATE_LIST_RECEIVE',

    USER_TEMPLATE_REQUEST: 'USER_TEMPLATE_REQUEST',
    USER_TEMPLATE_RECEIVE: 'USER_TEMPLATE_RECEIVE'
};



// WEBPACK FOOTER //
// ./src/constants/user.constants.js